import { authErrorMessages } from '~/constants/auth';

export const getErrorMessage = (error: any, overrides?: typeof authErrorMessages) => {
    const code = error.code && error.code in authErrorMessages ? error.code : 'default';

    return { ...authErrorMessages, ...overrides }[code];
};
